import { z } from "zod";

export const CategorySchema = z.object({
  id: z.number().positive().min(1),
  code: z.string(),
  i18nLabel: z.string(),
});

export type Category = z.infer<typeof CategorySchema>;
